import type {LineRange} from '@github-ui/diffs/types'

/**
 * Determines whether the current review comment selection spans multiple lines.
 *
 * A selection is considered "multiline" when:
 * - the row is currently selected (isRowSelected === true),
 * - the selection includes both a start and end line number,
 * - and the start and end numbers are not equal.
 *
 * @param isRowSelected - whether the row is selected
 * @param selectedLineRange - the selected range of lines
 * @returns true if the selection spans multiple lines, false otherwise
 */
export const reviewCommentIsMultiline = (isRowSelected: boolean, selectedLineRange: LineRange) => {
  return isRowSelected &&
    selectedLineRange.startLineNumber &&
    selectedLineRange.endLineNumber &&
    selectedLineRange.startLineNumber !== selectedLineRange.endLineNumber
    ? true
    : false
}
